// @flow

import * as React from 'react';
import styled from 'styled-components';
import {
  OverviewItem,
  SplitOverviewItem,
  NoteOverviewItem,
} from './OverviewItem';

type Props = {
  id?: string,
  children: React.ChildrenArray<React.Element<typeof OverviewItem>>,
};

const StyledOverview = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;

  > li {
    border: none;
    border-bottom: solid 0.1em ${(props) => props.theme.disabledColor};
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }

  > li:last-child {
    border-bottom: none;
  }
`;

export default class Overview extends React.Component<Props> {
  static OverviewItem = OverviewItem;
  static SplitOverviewItem = SplitOverviewItem;
  static NoteOverviewItem = NoteOverviewItem;

  render() {
    return <StyledOverview>{this.props.children}</StyledOverview>;
  }
}
